declare global {
  interface Window {
    fbq: (...args: unknown[]) => void
    _fbq: (...args: unknown[]) => void
  }
}

const PIXEL_ID = '805905665253813'

let initialized = false

function loadPixelScript() {
  if (initialized) return
  initialized = true

  const n = (window.fbq = function (...args: unknown[]) {
    if ((n as any).callMethod) {
      ;(n as any).callMethod(...args)
    } else {
      ;(n as any).queue.push(args)
    }
  } as any)

  if (!window._fbq) window._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = [] as unknown[][]

  const t = document.createElement('script')
  t.async = true
  t.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const s = document.getElementsByTagName('script')[0]
  s?.parentNode?.insertBefore(t, s)

  window.fbq('init', PIXEL_ID)
}

export function trackPageView() {
  loadPixelScript()
  window.fbq('track', 'PageView')
}

export function trackAddToCart() {
  loadPixelScript()
  window.fbq('track', 'AddToCart', {
    content_name: 'Protocolo Cortisol Off',
    content_type: 'product',
    value: 27,
    currency: 'USD',
  })
}
